import styled from 'styled-components'

interface TableContainerProps {
  isVisible: boolean
}

export const TableContainer = styled.div<TableContainerProps>`
  display: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
`
